export default __webpack_public_path__ + "assets/c3ab8714bb59c83ee44fffacbd05ec1e.svg";